import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { uniqueId } from "lodash";

import { redemptionHistoryColumns } from "./cols";
import { RedemptionHistory } from "../../../models/Customer";
import { usePermissionStore } from "../../../stores/permissionStore";
import CustomPagination from "../../atoms/CustomPagination";
import EmptyState from "../../atoms/EmptyState";
import { styles } from "../insuranceInformation/DataGrid.styles";

interface RedemptionHistoryDataGridProps {
  data?: RedemptionHistory;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

const RedemptionHistoryDataGrid = ({
  data,
  loading,
  onPageChange,
}: RedemptionHistoryDataGridProps) => {
  const { permissions } = usePermissionStore();
  const withAjustPointsAuth =
    permissions &&
    Object.keys(permissions[0].allowedActions).includes("adjustPoints");

  if (!withAjustPointsAuth) {
    const actionsIndex = redemptionHistoryColumns.findIndex(
      item => item.field === "actions",
    );
    if (actionsIndex !== -1) {
      redemptionHistoryColumns.splice(actionsIndex, 1);
    }
  }
  return (
    <Stack height={666}>
      <DataGrid
        columnHeaderHeight={52}
        rowHeight={56}
        loading={loading}
        data-testid="redemption-history-table"
        sx={styles.table}
        isRowSelectable={() => false}
        rows={data?.transactions || []}
        columns={redemptionHistoryColumns}
        getRowId={() => uniqueId()}
        slots={{
          pagination: CustomPagination,
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
        slotProps={{
          pagination: {
            count: data?.pagination?.totalPages,
            page: (data?.pagination?.currentPage ?? 1) - 1,
            onPageChange: (_, page) => {
              onPageChange(page + 1);
            },
          },
        }}
      />
    </Stack>
  );
};

export default RedemptionHistoryDataGrid;
